import React from "react";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import 'assets/css/wrap-image.css'
import { toCdnUrl } from "./to-cdn-url";

const wrapImage = (img: JSX.Element) => {
  const src = img?.props?.src;
  const rewritten =
    typeof src === "string"
      ? React.cloneElement(img, { src: toCdnUrl(src) })
      : img;

  return (
    <Zoom classDialog='custom-zoom'>
      {rewritten}
    </Zoom>
  )
}

export default wrapImage
